


































import { defineComponent, PropType } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import BaseButton from "@/components/BaseButton";
import BaseList, { BaseListItem } from "@/components/BaseList";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import CardItem from "../CardItem";

export default defineComponent({
  name: "CardListView",
  components: { CardItem, PageTitle, BaseList, BaseListItem, BaseButton, EmptyContent },
  props: {
    cards: { type: Array as PropType<CreditCardAssignment[]>, required: true },
  },
});
